import { render, staticRenderFns } from "./SlidebarUsers.vue?vue&type=template&id=5d1c1563"
import script from "./SlidebarUsers.vue?vue&type=script&lang=js"
export * from "./SlidebarUsers.vue?vue&type=script&lang=js"
import style0 from "./SlidebarUsers.vue?vue&type=style&index=0&id=5d1c1563&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports